import React, { useEffect } from 'react';
import { useExtensions } from '../hooks/useExtensions';

const AnalyticsLoader: React.FC = () => {
    const { config } = useExtensions();

    useEffect(() => {
        if (!config || !config.analytics || !config.analytics.google) return;

        const googleConfig = config.analytics.google;
        const measurementId = googleConfig.measurementId || googleConfig.trackingId;

        if (measurementId) {
            // Load Google Analytics
            const script = document.createElement('script');
            script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
            script.async = true;
            document.head.appendChild(script);

            const inlineScript = document.createElement('script');
            inlineScript.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${measurementId}');
            `;
            document.head.appendChild(inlineScript);

            console.log(`Analytics loaded for ${measurementId}`);
        }
    }, [config]);

    return null;
};

export default AnalyticsLoader;
